export * from './edit-aviso-en-la-web/edit-aviso-en-la-web.component';
export * from './aviso-en-la-web.component'